import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  flex: {
    display: 'flex',
  },

  marginRightSm: {
    marginRight: '.5rem',
  },
})

export default useStyles
